
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { l as labelsMixin } from './labels-mixin.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'color';
import 'color-string';
import { i as isValidHex, D as DEFAULT_PRESETS, g as getColor, t as toRgbString, a as getAlpha, n as normalizeHex } from './color-picker-helper-mixin.js';
import 'lodash/isNumber';
import { t as trapFocus, b as setFocusToFirstNode } from './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import { P as PickerPopover } from './picker-popover-mixin.js';
import { C as ColorPickerCheckboard, a as ColorPickerSwatch, b as ColorPickerPresets } from './pendo-color-picker-presets-mixin.js';

var script = {
  name: 'ColorPickerInput',
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    },
    valueKey: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    max: {
      type: Number,
      default: 255
    },
    min: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEscKeydown() {
      this.$refs.input.blur();
    },

    onInput(event) {
      const value = event.target.value;
      this.$emit('change', {
        [this.valueKey]: value
      });

      if (!this.$refs.input) {
        return;
      }

      this.$refs.input.value = value;
    },

    onBlur(event) {
      if (this.disabled) {
        return;
      }

      if (this.valueKey === 'hex') {
        this.onInput(event);

        if (!isValidHex(event.target.value)) {
          this.$refs.input.value = this.value;
        }
      }

      this.$emit('blur', event);
    },

    onFocus(event) {
      if (this.disabled) {
        return;
      }

      this.$emit('focus', event);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-color-picker-input",
    class: "pendo-color-picker-input--" + _vm.valueKey
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "min": _vm.min,
      "max": _vm.max,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.onFocus,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.onEscKeydown($event);
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.valueKey
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label || _vm.valueKey) + "\n    ")])]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "color-picker-input.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerInput = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'ColorPickerSaturation',
  props: {
    color: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 138
    },
    width: {
      type: Number,
      default: 184
    }
  },

  data() {
    return {
      cursor: {},
      canvas: {},
      ctx: null
    };
  },

  watch: {
    color() {
      this.setCanvasBackground();
      this.handleValueChange();
    }

  },

  async mounted() {
    await this.$nextTick();
    this.initCanvas();
    this.handleValueChange();
  },

  methods: {
    initCanvas() {
      this.ctx = this.$refs.canvas.getContext('2d');
      this.canvas = this.$refs.canvas.getBoundingClientRect();
      this.setCanvasBackground();
    },

    handleValueChange() {
      const _this$canvas = this.canvas,
            width = _this$canvas.width,
            height = _this$canvas.height;
      const x = this.color.hsv.s / 100 * width;
      const y = (100 - this.color.hsv.v) / 100 * height;
      this.cursor = {
        x,
        y
      };
    },

    updateCursorPosition({
      x,
      y
    }) {
      const _this$canvas2 = this.canvas,
            left = _this$canvas2.left,
            top = _this$canvas2.top,
            width = _this$canvas2.width,
            height = _this$canvas2.height;
      const normalized = {
        x: Math.min(Math.max(x - left, 0), width),
        y: Math.min(Math.max(y - top, 0), height)
      };
      this.cursor = normalized;
      this.updateColor();
    },

    updateColor() {
      const _this$cursor = this.cursor,
            x = _this$cursor.x,
            y = _this$cursor.y;
      const _this$canvas3 = this.canvas,
            width = _this$canvas3.width,
            height = _this$canvas3.height;
      const saturation = x * 100 / width;
      const bright = 100 - y * 100 / height;
      this.$emit('change', _objectSpread({}, this.color.hsv, {
        s: Math.round(saturation),
        v: Math.round(bright)
      }));
    },

    setCanvasBackground() {
      const _this$canvas4 = this.canvas,
            width = _this$canvas4.width,
            height = _this$canvas4.height;
      this.ctx.clearRect(0, 0, width, height);
      this.ctx.fillStyle = `hsl(${this.color.hsv.h}, 100%, 50%)`;
      this.ctx.fillRect(0, 0, width, height);
      const gradientWhite = this.ctx.createLinearGradient(0, 0, width, 0);
      gradientWhite.addColorStop(0, 'hsl(0, 0%, 100%)');
      gradientWhite.addColorStop(1, 'hsla(0, 0%, 100%, 0)');
      this.ctx.fillStyle = gradientWhite;
      this.ctx.fillRect(0, 0, width, height);
      const gradientBlack = this.ctx.createLinearGradient(0, 0, 0, height);
      gradientBlack.addColorStop(0, 'hsla(0, 0%, 0%, 0)');
      gradientBlack.addColorStop(1, 'hsl(0, 0%, 0%)');
      this.ctx.fillStyle = gradientBlack;
      this.ctx.fillRect(0, 0, width, height);
    },

    handleMouseDown({
      clientX,
      clientY
    }) {
      this.canvas = this.$refs.canvas.getBoundingClientRect();
      this.updateCursorPosition({
        x: clientX,
        y: clientY
      });

      const handleMouseMove = evnt => {
        window.requestAnimationFrame(() => {
          this.updateCursorPosition({
            x: evnt.clientX,
            y: evnt.clientY
          });
        });
      };

      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-color-picker-saturation",
    style: {
      height: _vm.height + "px",
      width: _vm.width + "px"
    }
  }, [_c('div', {
    staticClass: "pendo-color-picker-saturation__border"
  }), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    staticClass: "pendo-color-picker-saturation__canvas",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    },
    on: {
      "mousedown": function ($event) {
        $event.preventDefault();
        return _vm.handleMouseDown($event);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-color-picker-saturation__pointer",
    style: "transform: translate3d(" + _vm.cursor.x + "px, " + _vm.cursor.y + "px, 0)"
  })]);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "color-picker-saturation.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerSaturation = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  name: 'ColorPickerSlider',
  components: {
    ColorPickerCheckboard
  },
  props: {
    valueKey: {
      type: String,
      required: true
    },
    color: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      oldValue: 0
    };
  },

  computed: {
    isAlpha() {
      return this.valueKey === 'alpha';
    },

    isHue() {
      return this.valueKey === 'h';
    },

    value() {
      if (this.isHue) {
        if (this.color.hsl.h === 0 && this.oldValue > 359) {
          return 360;
        }

        return this.color.hsl.h;
      }

      return this.color.alpha * 100;
    },

    gradientColor() {
      if (this.isHue) {
        return 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)';
      }

      const rgb = `${this.color.r}, ${this.color.g}, ${this.color.b}`;
      return `linear-gradient(to right, rgba(${rgb}, 0) 0%, rgba(${rgb}, 1) 100%)`;
    }

  },
  methods: {
    onInput(event) {
      let value = event.target.valueAsNumber;

      if (this.isAlpha) {
        value /= 100;
      }

      this.oldValue = value;
      this.$emit('change', _objectSpread({}, this.color.hsl, {
        [this.valueKey]: value
      }));
    }

  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-color-picker-slider",
    class: {
      'pendo-color-picker-slider--alpha': _vm.isAlpha,
      'pendo-color-picker-slider--hue': _vm.isHue
    }
  }, [_c('div', {
    staticClass: "pendo-color-picker-slider__gradient",
    style: {
      background: _vm.gradientColor
    }
  }), _vm._v(" "), _vm.isAlpha ? _c('color-picker-checkboard', {
    staticClass: "pendo-color-picker-slider__checkboard"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-color-picker-slider__control"
  }, [_c('input', {
    attrs: {
      "type": "range",
      "min": 0,
      "max": _vm.isHue ? 360 : 100
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  })])], 1);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "color-picker-slider.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerSlider = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

var script$3 = {
  name: 'PendoColorPicker',
  components: {
    ColorPickerSwatch,
    ColorPickerSlider,
    ColorPickerInput,
    ColorPickerSaturation,
    ColorPickerPresets,
    PickerPopover
  },
  mixins: [labelsMixin],
  props: {
    initialColor: {
      type: [String, Object],
      default: '#000000'
    },
    value: {
      type: [String, Object],
      default: null
    },
    valueKey: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disablePresets: {
      type: Boolean,
      default: false
    },
    disableAlpha: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    },
    presets: {
      type: Array,
      default: () => DEFAULT_PRESETS
    },
    triggerWidth: {
      type: [Number, String],
      default: 132
    },
    placement: {
      type: String,
      default: 'auto-start'
    },
    popperConfig: {
      type: Object,
      default: () => ({
        placement: 'auto-end'
      })
    }
  },

  data() {
    return {
      isFocused: false,
      isVisible: false,
      internalColor: null
    };
  },

  computed: {
    color: {
      get() {
        return getColor(this.value ? this.value : this.internalColor);
      },

      set(color) {
        this.internalColor = color;
        this.$emit('input', color[this.valueKey] || color);
        this.$emit('change', color[this.valueKey] || color);
      }

    },

    pickerTriggerWidth() {
      if (typeof this.triggerWidth === 'string') {
        return this.triggerWidth;
      }

      return `${this.triggerWidth}px`;
    },

    isActive() {
      return this.isFocused || this.isVisible;
    },

    activeColor() {
      return toRgbString(this.color);
    }

  },
  watch: {
    isActive(val) {
      this.$emit('active', val);
    }

  },

  created() {
    this.color = getColor(this.value ? this.value : this.initialColor);
  },

  methods: {
    isTransparent(color) {
      return getAlpha(color) === 0;
    },

    updateColor(data) {
      this.color = getColor(data);
    },

    handlePresetClick(color) {
      this.updateColor({
        hex: color
      });
    },

    handleChildChange(data) {
      this.updateColor(_objectSpread({
        alpha: this.color.alpha
      }, data));
    },

    handleInputChange(data) {
      if (!data) {
        return;
      }

      const hex = data.hex,
            r = data.r,
            g = data.g,
            b = data.b,
            alpha = data.alpha;

      if (hex && isValidHex(hex)) {
        this.updateColor({
          hex: normalizeHex(hex)
        });
      } else if (r !== undefined || g !== undefined || b !== undefined || alpha !== undefined) {
        this.updateColor({
          r: r !== undefined ? r : this.color.r,
          g: g !== undefined ? g : this.color.g,
          b: b !== undefined ? b : this.color.b,
          alpha: alpha !== undefined ? alpha / 100 : this.color.alpha
        });
      }
    },

    handleInputFocus() {
      if (this.isFocused) {
        return;
      }

      this.isFocused = true;
    },

    handleInputBlur() {
      this.isFocused = false;
    },

    toggleColorPicker() {
      if (this.isVisible) {
        this.hideColorPicker();
      } else {
        this.showColorPicker();
      }
    },

    async onEscKeydown() {
      this.hideColorPicker();
      await this.$nextTick();
      this.$refs.triggerSwatch.$el.focus();
    },

    onTabKeydown(event) {
      trapFocus(event, this.$refs.panel);
    },

    async showColorPicker() {
      this.isVisible = true;
      this.$emit('show', this.color[this.valueKey] || this.color);
      await this.$nextTick();
      setFocusToFirstNode(this.$refs.popover.$refs.popper);
    },

    hideColorPicker() {
      this.isVisible = false;
      this.$emit('hide', this.color[this.valueKey] || this.color);
    }

  }
};

const __vue_script__$3 = script$3;

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-color-picker",
    class: {
      'pendo-color-picker--inline-label': !!_vm.inlineLabel,
      'pendo-color-picker--alpha': !_vm.disableAlpha,
      'pendo-color-picker--presets': !_vm.disablePresets,
      'is-open': _vm.isVisible
    }
  }, [!!_vm.topLabel ? _c('div', {
    staticClass: "pendo-color-picker__label pendo-color-picker__label--top"
  }, [_vm._v("\n        " + _vm._s(_vm.topLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('picker-popover', {
    ref: "popover",
    attrs: {
      "is-open": _vm.isVisible,
      "append-to-body": true,
      "popper-options": {
        placement: 'auto-start',
        class: 'pendo-color-picker__popover'
      }
    },
    on: {
      "click-outside": _vm.hideColorPicker
    },
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function () {
        return [_c('div', {
          ref: "panel",
          staticClass: "pendo-color-picker__panel",
          class: {
            'pendo-color-picker__panel--alpha': !_vm.disableAlpha,
            'pendo-color-picker__panel--presets': !_vm.disablePresets,
            'alpha-disabled': _vm.disableAlpha
          },
          attrs: {
            "tabindex": "0"
          },
          on: {
            "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
                return null;
              }

              return _vm.onEscKeydown($event);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
                return null;
              }

              return _vm.onTabKeydown($event);
            }]
          }
        }, [_c('div', {
          staticClass: "panel-saturation"
        }, [_c('color-picker-saturation', {
          attrs: {
            "width": !_vm.disableAlpha ? 200 : 184,
            "color": _vm.color
          },
          on: {
            "change": _vm.handleChildChange
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "panel-control-group"
        }, [_c('div', {
          staticClass: "panel-sliders"
        }, [_c('color-picker-slider', {
          staticClass: "panel-hue",
          attrs: {
            "value-key": "h",
            "color": _vm.color
          },
          on: {
            "change": _vm.handleChildChange
          }
        }), _vm._v(" "), !_vm.disableAlpha ? _c('color-picker-slider', {
          staticClass: "panel-alpha",
          attrs: {
            "value-key": "alpha",
            "color": _vm.color
          },
          on: {
            "change": _vm.handleChildChange
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('color-picker-swatch', {
          attrs: {
            "color": _vm.activeColor,
            "size": "100%"
          }
        })], 1), _vm._v(" "), !_vm.disableFields ? _c('div', {
          staticClass: "panel-input-group"
        }, [_c('div', {
          staticClass: "panel-input-group--hex"
        }, [_c('color-picker-input', {
          attrs: {
            "value": _vm.color.hex,
            "maxlength": !_vm.disableAlpha ? 9 : 7,
            "type": "text",
            "value-key": "hex"
          },
          on: {
            "change": _vm.handleInputChange
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "panel-input-group--rgba"
        }, [_c('color-picker-input', {
          attrs: {
            "value": _vm.color.r,
            "max": 255,
            "type": "number",
            "value-key": "r"
          },
          on: {
            "change": _vm.handleInputChange
          }
        }), _vm._v(" "), _c('color-picker-input', {
          attrs: {
            "value": _vm.color.g,
            "max": 255,
            "type": "number",
            "value-key": "g"
          },
          on: {
            "change": _vm.handleInputChange
          }
        }), _vm._v(" "), _c('color-picker-input', {
          attrs: {
            "value": _vm.color.b,
            "max": 255,
            "type": "number",
            "value-key": "b"
          },
          on: {
            "change": _vm.handleInputChange
          }
        }), _vm._v(" "), !_vm.disableAlpha ? _c('color-picker-input', {
          attrs: {
            "value": _vm.color.alpha * 100,
            "max": 100,
            "type": "number",
            "value-key": "alpha",
            "label": "a"
          },
          on: {
            "change": _vm.handleInputChange
          }
        }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), !_vm.disablePresets ? _c('div', {
          staticClass: "panel-presets-group"
        }, [_c('color-picker-presets', {
          attrs: {
            "value": _vm.color.hex,
            "presets": _vm.presets,
            "size": 16
          },
          on: {
            "change": _vm.handlePresetClick
          }
        })], 1) : _vm._e()])];
      },
      proxy: true
    }])
  }, [_c('div', {
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:color-picker',
        value: _vm.analyticsTagFromLabels
      },
      expression: "{ type: 'components:color-picker', value: analyticsTagFromLabels }"
    }],
    staticClass: "pendo-color-picker__trigger",
    class: [{
      'is-active': _vm.isActive,
      'is-disabled': _vm.disabled
    }],
    style: {
      width: _vm.pickerTriggerWidth
    }
  }, [_c('color-picker-swatch', {
    ref: "triggerSwatch",
    staticClass: "pendo-color-picker__trigger-swatch",
    attrs: {
      "color": _vm.activeColor,
      "size": 20,
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleColorPicker,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.toggleColorPicker($event);
      }
    }
  }), _vm._v(" "), _c('color-picker-input', {
    staticClass: "pendo-color-picker__trigger-input",
    attrs: {
      "disabled": _vm.disabled,
      "value": _vm.color.hex,
      "maxlength": !_vm.disableAlpha ? 9 : 7,
      "value-key": "hex",
      "type": "text"
    },
    on: {
      "focus": _vm.handleInputFocus,
      "blur": _vm.handleInputBlur,
      "change": _vm.handleInputChange
    }
  })], 1)]), _vm._v(" "), _vm.bottomLabel ? _c('div', {
    staticClass: "pendo-color-picker__label pendo-color-picker__label--bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.bottomLabel) + "\n    ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$3 = [];
const __vue_inject_styles__$3 = undefined;
const __vue_scope_id__$3 = undefined;
const __vue_is_functional_template__$3 = false;

function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-color-picker.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoColorPicker = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3);

export default pendoColorPicker;
